/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '@openx/types/gqlTypes.ts';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type SessionQueryVariables = Exact<{ [key: string]: never; }>;


export type SessionQuery = { getSession: any };


export const SessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSession"}}]}}]} as unknown as DocumentNode<SessionQuery, SessionQueryVariables>;